import store from '@src/store';

export const RESIN_ORDER_START = 'RESIN_ORDER_START';
export const RESIN_ORDER_SUCCESS = 'RESIN_ORDER_SUCCESS';
export const RESIN_ORDER_ERROR = 'RESIN_ORDER_ERROR';
export const RESIN_ORDER_CANCEL = 'RESIN_ORDER_CANCEL';
export const RESIN_ORDER_LOADING = 'RESIN_ORDER_LOADING';
export const RESIN_SPECULATIVE_START = 'RESIN_SPECULATIVE_START';
export const RESIN_SPECULATIVE_SUCCESS = 'RESIN_SPECULATIVE_SUCCESS';
export const RESIN_SPECULATIVE_ERROR = 'RESIN_SPECULATIVE_ERROR';
export const RESIN_SPECULATIVE_CANCEL = 'RESIN_SPECULATIVE_CANCEL';

export type Actions = {
  RESIN_ORDER_START: { type: typeof RESIN_ORDER_START; payload: boolean};
  RESIN_ORDER_LOADING: { type: typeof RESIN_ORDER_LOADING; payload: boolean };
  RESIN_ORDER_SUCCESS: { type: typeof RESIN_ORDER_SUCCESS; payload: any};
  RESIN_ORDER_ERROR: { type: typeof RESIN_ORDER_ERROR; payload: any };
  RESIN_ORDER_CANCEL: { type: typeof RESIN_ORDER_CANCEL; payload: any };
  RESIN_SPECULATIVE_START: { type: typeof RESIN_SPECULATIVE_START; payload: boolean};
  RESIN_SPECULATIVE_SUCCESS: { type: typeof RESIN_SPECULATIVE_SUCCESS; payload: any};
  RESIN_SPECULATIVE_ERROR: { type: typeof RESIN_SPECULATIVE_ERROR; payload: any };
  RESIN_SPECULATIVE_CANCEL: { type: typeof RESIN_SPECULATIVE_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  resinOrderStart: (payload: any): Actions[typeof RESIN_ORDER_START] => ({
    type: RESIN_ORDER_START,
    payload,
  }),
  resinOrderError: (payload: any): Actions[typeof RESIN_ORDER_ERROR] => ({
    type: RESIN_ORDER_ERROR,
    payload,
  }),
  resinOrderSuccess: (payload: any): Actions[typeof RESIN_ORDER_SUCCESS] => ({
    type: RESIN_ORDER_SUCCESS,
    payload
  }),
  resinOrderLoading: ( payload: boolean ): Actions[typeof RESIN_ORDER_LOADING] => ({
    type: RESIN_ORDER_LOADING,
    payload,
  }),
  resinOrderCancel: (payload: boolean): Actions[typeof RESIN_ORDER_CANCEL] => ({
    type: RESIN_ORDER_CANCEL, payload,
  }),
  resinSpeculativeStart: (payload: any): Actions[typeof RESIN_SPECULATIVE_START] => ({
    type: RESIN_SPECULATIVE_START,
    payload,
  }),
  resinSpeculativeError: (payload: any): Actions[typeof RESIN_SPECULATIVE_ERROR] => ({
    type: RESIN_SPECULATIVE_ERROR,
    payload,
  }),
  resinSpeculativeSuccess: (payload: any): Actions[typeof RESIN_SPECULATIVE_SUCCESS] => ({
    type: RESIN_SPECULATIVE_SUCCESS,
    payload
  }),
  resinSpeculativeCancel: (payload: boolean): Actions[typeof RESIN_SPECULATIVE_CANCEL] => ({
    type: RESIN_SPECULATIVE_CANCEL, payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/resin-order/actions.ts